import type { IServiceConsumer } from '@frontend/components/interfaces/serviceConsumer';
import { ServiceCode } from '@common/enums';
import { fetchJson } from '@frontend/store/fetch';

const baseUrl = '/api/serviceConsumers';

export async function hasActiveGgzbTherServiceConsumerRights(employmentId: string, signal: AbortSignal) {
    const url = `${baseUrl}?employmentId=${employmentId}&isActive=true`;
    const result = await fetchJson({ method: 'GET', signal, url });

    return result.json.items.some((item: IServiceConsumer) => item.service.code === ServiceCode.GGZBther);
}
